export const cohortBuilderEmptyStateCardMessagesEn = {
  // Cohort Builder - Cohort Builder Empty State Card
  'projects.cohortBuilderPage.cohortBuilderEmptyStateCard.mainMessage': 'No items',
  'projects.cohortBuilderPage.cohortBuilderEmptyStateCard.subMessage': 'Add an item to get started',
};
